import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faClockRotateLeft } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'
import MailingMessageList from '../../../components/MailingMessageList/MailingMessageList.js'

import { boxvar2_1, boxvar4, URL_MAINAPI, API_TOKEN } from '../../../main.js'

import '../../../main.css'
import '../../Manage/ManageEventMailings/ManageEventMailings.css'
import '../../Manage/ManageEventMailings/MManageEventMailings.css'

import Cookies from 'universal-cookie'

export default function ProfilMessages() {

    const cookies = new Cookies()
    let cur_authtoken = cookies.get('authtoken')

    const { eventid } = useParams()

    var [messages, setMessages] = useState([])
    var [loadedMessages, setLoadedMessages] = useState(0)
    var [eventName, setEventName] = useState("")

    useEffect(() => {
        getMessages()
    }, [eventid])

    function markRead(id) {
        // Optimistisch lokal setzen
        setMessages(prev => prev.map(m => (m._id === id ? { ...m, read: true } : m)))
        try {
            fetch(URL_MAINAPI + "/mailing/myhistory/" + id + "/read", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            })
        } catch (err) {
            /* Markierung ist unkritisch */
        }
    }

    function getMessages() {
        try {
            setLoadedMessages(0)
            const route = eventid ? ("/mailing/myhistory/" + eventid) : "/mailing/myhistory"
            fetch(URL_MAINAPI + route, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    const list = Array.isArray(res.data.data) ? res.data.data : []
                    setMessages(list)
                    if (eventid) {
                        const named = list.find(m => m.eventName)
                        setEventName(named ? named.eventName : "")
                    }
                    setLoadedMessages(1)
                } else {
                    setMessages([])
                    setLoadedMessages(1)
                }
            }))
        } catch (err) {
            setMessages([])
            setLoadedMessages(1)
        }
    }

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Meine Nachrichten</title>
                <meta property="og:title" content="Meine Nachrichten" />
                <meta property="og:description" content="Nachrichten der Veranstalter" />
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body container section' style={{ paddingTop: '36px' }}>
                <div className='breadcrumb'>
                    <a href='/profil'>Profil</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    {eventid ? <><a href={'/event/' + eventid}>{eventName || 'Event'}</a><FontAwesomeIcon icon={faChevronRight} /></> : null}
                    <span>Nachrichten</span>
                </div>

                <motion.h1
                    variants={boxvar4}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-50px" }}
                    className='section-title'
                    style={{ marginBottom: '6px' }}
                >
                    📨 Meine Nachrichten
                </motion.h1>
                {eventid
                    ? (loadedMessages
                        ? <p className='section-sub'>für <a href={"/event/" + eventid}>{eventName || 'dieses Event'}</a></p>
                        : <Skeleton width="240px" />)
                    : <p className='section-sub'>Nachrichten der Veranstalter und des Helferzeit-Teams</p>}

                <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} style={{ marginTop: '20px' }}>
                    <div className='card mailings-history-card' style={{ padding: '28px 30px', maxWidth: '820px' }}>
                        <div className='mailings-headline'>
                            <span className='mailings-icon'><FontAwesomeIcon icon={faClockRotateLeft} /></span>
                            <h3>Letzte Nachrichten</h3>
                        </div>
                        <p className='mailings-history-hint'>
                            {eventid
                                ? 'Rundmails des Veranstalters, bei denen du als Empfänger eingetragen warst.'
                                : 'Rundmails der Veranstalter deiner Events sowie Plattformnachrichten von Helferzeit.'}
                        </p>

                        <MailingMessageList
                            items={messages}
                            loaded={!!loadedMessages}
                            emptyText="Du hast noch keine Nachrichten erhalten."
                            showEvent={!eventid}
                            showReadState
                            onMarkRead={markRead}
                            allowPdfDownload
                        />
                    </div>
                </motion.div>
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
